(() => {
  const root = document.querySelector("[data-rcq-skinquiz]");
  if (!root || !window.RCQ_SKIN_TEST || !window.RCQ_RULES) return;

  const data = window.RCQ_SKIN_TEST;
  const answers = {};
  let current = 0;
  const q = selector => root.querySelector(selector);
  const intro = q(".rcq-skinquiz__intro");
  const quiz = q("[data-rcq-quiz]");
  const result = q("[data-rcq-result]");
  const advicePanel = q("[data-rcq-advice-panel]");
  const list = q("[data-rcq-answer-list]");

  const adviceForm = advicePanel.querySelector("form");
  const adviceMessageField = advicePanel.querySelector("[data-rcq-advice-message]");
  const extraQuestionField = advicePanel.querySelector("[data-rcq-extra-question]");
  const contactAnswersList = advicePanel.querySelector("[data-rcq-contact-answers]");
  const additionalQuestionMarker = "\n\nEventuele aanvullende vraag:\n";

  if (advicePanel.querySelector("[data-rcq-contact-response]")) {
    restoreAnswersFromContactMessage();
    renderContactAnswerSummary();
    intro.hidden = true;
    quiz.hidden = true;
    result.hidden = true;
    advicePanel.hidden = false;
    if (adviceMessageField && extraQuestionField) {
      const markerIndex = adviceMessageField.value.lastIndexOf(additionalQuestionMarker);
      if (markerIndex >= 0) {
        const savedQuestion = adviceMessageField.value.slice(markerIndex + additionalQuestionMarker.length);
        if (savedQuestion !== "Geen aanvullende vraag toegevoegd.") extraQuestionField.value = savedQuestion;
      }
    }
  }

  q("[data-rcq-start]").addEventListener("click", () => {
    intro.hidden = true;
    quiz.hidden = false;
    renderQuestion();
  });
  q("[data-rcq-back]").addEventListener("click", () => {
    if (current === 0) {
      quiz.hidden = true;
      intro.hidden = false;
      return;
    }
    current -= 1;
    renderQuestion();
  });
  q("[data-rcq-form]").addEventListener("submit", event => {
    event.preventDefault();
    const question = data.questions[current];
    if (!isAnswered(question)) {
      q("[data-rcq-error]").hidden = false;
      return;
    }
    q("[data-rcq-error]").hidden = true;
    saveCurrent(question);
    if (current < data.questions.length - 1) {
      current += 1;
      renderQuestion();
    } else {
      renderResult();
    }
  });

  if (adviceForm && adviceMessageField) {
    adviceForm.addEventListener("submit", () => {
      const extraQuestion = extraQuestionField.value.trim();
      if (hasAllAnswers()) {
        adviceMessageField.value = formatAnswersForContact();
      } else {
        const markerIndex = adviceMessageField.value.lastIndexOf(additionalQuestionMarker);
        if (markerIndex >= 0) {
          const savedAnswers = adviceMessageField.value.slice(0, markerIndex);
          adviceMessageField.value = `${savedAnswers}${additionalQuestionMarker}${extraQuestion || "Geen aanvullende vraag toegevoegd."}`;
        }
      }
    });
  }

  const adviceBackButton = advicePanel.querySelector("[data-rcq-advice-back]");
  if (adviceBackButton) {
    adviceBackButton.addEventListener("click", () => {
      advicePanel.hidden = true;
      result.hidden = false;
      const adviceButton = result.querySelector("[data-rcq-advice-open]");
      if (adviceButton) adviceButton.focus({ preventScroll: true });
      root.scrollIntoView({ block: "start", behavior: "smooth" });
    });
  }

  function renderQuestion() {
    const question = data.questions[current];
    q("[data-rcq-kicker]").textContent = question.kicker;
    q("[data-rcq-question-title]").textContent = question.title;
    q("[data-rcq-help]").textContent = question.help;
    q("[data-rcq-step]").textContent = `Vraag ${current + 1} van ${data.questions.length}`;
    const percent = Math.round((current / data.questions.length) * 100);
    q("[data-rcq-percent]").textContent = `${percent}%`;
    q("[data-rcq-progress-fill]").style.width = `${percent}%`;
    q("[data-rcq-progress]").setAttribute("aria-valuenow", String(percent));
    q("[data-rcq-back]").textContent = current === 0 ? "← Intro" : "← Vorige";
    q("[data-rcq-next]").textContent = current === data.questions.length - 1 ? "Bekijk mijn advies →" : "Volgende →";
    list.replaceChildren();
    question.answers.forEach((answer, index) => {
      const wrapper = document.createElement("div");
      wrapper.className = "rcq-skinquiz__answer-option";
      const input = document.createElement("input");
      input.type = question.type;
      input.name = `rcq-${question.id}`;
      input.id = `rcq-${root.id}-${question.id}-${index}`;
      input.value = answer.value;
      if (question.type === "checkbox") input.checked = (answers[question.id] || []).includes(answer.value);
      else input.checked = answers[question.id] === answer.value;
      input.addEventListener("change", () => {
        if (question.type === "checkbox") {
          const selected = [...list.querySelectorAll("input:checked")];
          if (question.max && selected.length > question.max) {
            input.checked = false;
            q("[data-rcq-help]").textContent = `Kies maximaal ${question.max} wensen. ${question.help}`;
          } else {
            q("[data-rcq-help]").textContent = question.help;
          }
        }
        q("[data-rcq-error]").hidden = true;
      });
      const label = document.createElement("label");
      label.htmlFor = input.id;
      label.textContent = answer.label;
      wrapper.append(input, label);
      list.append(wrapper);
    });
    q("[data-rcq-question-title]").focus({ preventScroll: true });
    root.scrollIntoView({ block: "start", behavior: "smooth" });
  }

  function isAnswered(question) {
    if (question.type === "checkbox") return list.querySelectorAll("input:checked").length <= question.max;
    return Boolean(list.querySelector("input:checked"));
  }
  function saveCurrent(question) {
    answers[question.id] = question.type === "checkbox"
      ? [...list.querySelectorAll("input:checked")].map(input => input.value)
      : list.querySelector("input:checked").value;
  }
  function productRecord(key) {
    const element = root.querySelector(`[data-rcq-kit-record="${key}"]`);
    if (!element) return null;
    return {
      title: element.dataset.title,
      url: element.dataset.url,
      image: element.dataset.image,
      imageAlt: element.dataset.imageAlt,
      price: element.dataset.price,
      discountUrl: element.dataset.discountUrl,
      available: element.dataset.available === "true"
    };
  }
  function renderResult() {
    quiz.hidden = true;
    result.hidden = false;
    const outcome = window.RCQ_RULES.resolve(answers, data);
    const kit = outcome.kit ? data.kits[outcome.kit] : null;
    const product = outcome.kit ? productRecord(outcome.kit) : null;
    const adviceHTML = outcome.advice.split(/\n{2,}/).map(text => `<p>${escapeHTML(text)}</p>`).join("");
    const kitBlock = kit && product
      ? `<div class="rcq-skinquiz__kit-card">${product.image ? `<a href="${escapeAttr(product.url)}" aria-label="Bekijk ${escapeAttr(product.title)}"><img src="${escapeAttr(product.image)}" alt="${escapeAttr(product.imageAlt || product.title)}" loading="lazy"></a>` : ""}<div><h3>${escapeHTML(product.title)}</h3><p>${escapeHTML(kit.officialText)}</p><p class="rcq-skinquiz__kit-price">${escapeHTML(product.price.replace(/,00(?=\s*EUR$)/, "").replace(/\s*EUR$/, ""))}</p>${product.available ? "" : `<p class="rcq-skinquiz__availability">Deze Trial Kit is op dit moment niet beschikbaar.</p>`}</div></div>`
      : kit
        ? `<p class="rcq-skinquiz__setup-note">Deze testpagina is nog niet volledig ingesteld. De productkeuzes moeten eerst aan de drie Trial Kits worden gekoppeld.</p>`
      : `<p class="rcq-skinquiz__result-note">We adviseren je om je antwoorden met Red Carpet Queen te bespreken voordat je een set kiest. Je hoeft niets te kopen om dit advies te gebruiken.</p><button class="rcq-skinquiz__button rcq-skinquiz__button--primary" data-rcq-advice-open type="button">Vraag persoonlijk huidadvies →</button>`;
    const profileHTML = `<dl class="rcq-skinquiz__profile-list"><div><dt>Huidtype</dt><dd>${escapeHTML(outcome.profile.skinType)}</dd></div><div><dt>Droogtegevoel</dt><dd>${escapeHTML(outcome.profile.dryness)}</dd></div><div><dt>Reactie op verzorgingsproducten</dt><dd>${escapeHTML(outcome.profile.sensitivity)}</dd></div><div><dt>Ervaring met ESSE</dt><dd>${escapeHTML(outcome.profile.experience)}</dd></div><div><dt>Huidwensen</dt><dd>${outcome.profile.concerns.length ? escapeHTML(outcome.profile.concerns.join(" · ")) : "Geen specifieke wens gekozen"}</dd></div></dl>`;
    const gift = `<section class="rcq-skinquiz__gift-card" aria-labelledby="rcq-skinquiz-gift-title-${root.id}"><p class="rcq-skinquiz__eyebrow">Een bedankje voor jou</p><h2 id="rcq-skinquiz-gift-title-${root.id}">10% korting op ${kit ? "jouw aanbevolen" : "een ESSE"} Trial Kit</h2><p>Leuk dat je onze huidtest hebt ingevuld. Als bedankje krijg je 10% korting met code <strong class="rcq-skinquiz__discount-code">MIJNHUID</strong>.</p>${kit && product && product.available ? `<a class="rcq-skinquiz__button rcq-skinquiz__button--primary rcq-skinquiz__gift-link" href="${escapeAttr(product.discountUrl)}">Bekijk jouw Trial Kit met 10% korting →</a>` : `<p class="rcq-skinquiz__gift-note">${kit ? "De kortingslink verschijnt zodra de Trial Kits aan deze proefpagina zijn gekoppeld en beschikbaar zijn." : "We helpen je graag eerst kiezen welke Trial Kit bij je past."}</p>`}</section>`;
    result.innerHTML = `<article class="rcq-skinquiz__result-card"><header class="rcq-skinquiz__result-head"><p class="rcq-skinquiz__eyebrow">Persoonlijk advies van Red Carpet Queen</p><h1>Jouw persoonlijke huidadvies</h1><p>Een eerste advies, op basis van wat jij hebt verteld.</p></header><section class="rcq-skinquiz__result-section rcq-skinquiz__result-advice"><h2>Wat vertellen je antwoorden?</h2>${adviceHTML}</section><section class="rcq-skinquiz__result-section"><h2>${kit ? "Waarom adviseren we deze Trial Kit?" : "Waarom nog geen kit?"}</h2><p>${escapeHTML(outcome.reason)}</p></section><section class="rcq-skinquiz__result-section"><h2>${kit ? "Jouw aanbevolen Trial Kit" : "Samen een passende Trial Kit kiezen"}</h2>${kitBlock}</section>${gift}<details class="rcq-skinquiz__answers-details"><summary>Bekijk jouw antwoorden <span aria-hidden="true">▾</span></summary>${profileHTML}</details><p class="rcq-skinquiz__result-note rcq-skinquiz__disclaimer">Dit is een eerste cosmetisch advies op basis van je antwoorden, geen medische diagnose.</p><button class="rcq-skinquiz__button rcq-skinquiz__button--quiet rcq-skinquiz__restart" data-rcq-restart type="button">← Opnieuw beginnen</button></article>`;
    const adviceButton = result.querySelector("[data-rcq-advice-open]");
    if (adviceButton) adviceButton.addEventListener("click", openAdviceForm);
    q("[data-rcq-restart]").addEventListener("click", restart);
    result.querySelector("h1").focus({ preventScroll: true });
    root.scrollIntoView({ block: "start", behavior: "smooth" });
  }
  function openAdviceForm() {
    renderContactAnswerSummary();
    result.hidden = true;
    advicePanel.hidden = false;
    advicePanel.querySelector("h2").focus({ preventScroll: true });
    root.scrollIntoView({ block: "start", behavior: "smooth" });
  }
  function hasAllAnswers() {
    return data.questions.every(question => Object.prototype.hasOwnProperty.call(answers, question.id));
  }
  function restoreAnswersFromContactMessage() {
    if (!adviceMessageField?.value) return;
    const lines = adviceMessageField.value.split(/\r?\n/);
    data.questions.forEach((question, index) => {
      const answerLines = lines.indexOf(`${index + 1}. ${question.title}`);
      if (answerLines < 0) return;
      const values = [];
      for (let lineIndex = answerLines + 1; lineIndex < lines.length; lineIndex += 1) {
        const line = lines[lineIndex];
        if (/^\d+\. /.test(line) || line === "Eventuele aanvullende vraag:") break;
        if (line === "Geen huidwensen gekozen." && question.id === "concerns") {
          answers[question.id] = [];
          break;
        }
        if (!line.startsWith("- ")) continue;
        const answer = question.answers.find(option => option.label === line.slice(2));
        if (answer) values.push(answer.value);
      }
      if (question.type === "checkbox") answers[question.id] = values.slice(0, question.max || values.length);
      else if (values.length) answers[question.id] = values[0];
    });
  }
  function renderContactAnswerSummary() {
    if (!contactAnswersList) return;
    contactAnswersList.replaceChildren();
    data.questions.forEach(question => {
      const selected = answers[question.id];
      const values = Array.isArray(selected)
        ? selected.slice(0, question.max || selected.length)
        : selected ? [selected] : [];
      const labels = values
        .map(value => question.answers.find(answer => answer.value === value)?.label)
        .filter(Boolean);
      const row = document.createElement("div");
      const title = document.createElement("dt");
      const response = document.createElement("dd");
      title.textContent = question.title;
      response.textContent = labels.length
        ? labels.join(" · ")
        : question.id === "concerns" ? "Geen huidwensen gekozen." : "Geen antwoord opgeslagen.";
      row.append(title, response);
      contactAnswersList.append(row);
    });
  }
  function formatAnswersForContact() {
    const formattedAnswers = data.questions.map((question, index) => {
      const selected = answers[question.id];
      const values = Array.isArray(selected)
        ? selected.slice(0, question.max || selected.length)
        : selected ? [selected] : [];
      const labels = values
        .map(value => question.answers.find(answer => answer.value === value)?.label)
        .filter(Boolean);
      const answerLines = labels.length
        ? labels.map(label => `- ${label}`).join("\n")
        : question.id === "concerns" ? "Geen huidwensen gekozen." : "Geen antwoord opgeslagen.";
      return `${index + 1}. ${question.title}\n${answerLines}`;
    }).join("\n\n");
    const extraQuestion = advicePanel.querySelector("[data-rcq-extra-question]").value.trim();
    return [
      "Aanvraag persoonlijk huidadvies via de RCQ-huidtest",
      "",
      "Antwoorden:",
      formattedAnswers,
      "",
      "Eventuele aanvullende vraag:",
      extraQuestion || "Geen aanvullende vraag toegevoegd."
    ].join("\n");
  }
  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, character => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" })[character]);
  }
  function escapeAttr(value) { return escapeHTML(value); }
  function restart() {
    Object.keys(answers).forEach(key => delete answers[key]);
    current = 0;
    result.hidden = true;
    result.replaceChildren();
    intro.hidden = false;
    root.scrollIntoView({ block: "start", behavior: "smooth" });
    q("[data-rcq-start]").focus({ preventScroll: true });
  }
})();
